/**
 * Dispatched from `useMyLocation` after a successful apply once the localization cookie is saved.
 */
export const MY_LOCATION_COOKIE_UPDATED_EVENT = 'pmi:my-location-cookie-updated'

export type MyLocationCookieUpdatedDetail = {
  zipcode: string | null
  statecode: string | null
}

export function dispatchMyLocationCookieUpdated(
  detail?: MyLocationCookieUpdatedDetail
): void {
  if (typeof window === 'undefined') {
    return
  }
  window.dispatchEvent(
    new CustomEvent(MY_LOCATION_COOKIE_UPDATED_EVENT, { detail })
  )
}
